import React, { useEffect } from "react";
import { t } from "utilities/localization-utils";
import logo from "assets/images/nfpa-link-color.png";

const CSS_CLASS_NAME = "c-printable-page-page";

interface PrintablePageFooterProps {
    ownerEmail?: string;
    ownerFullName?: string;
}

const PrintablePageFooter = ({
    ownerEmail,
    ownerFullName,
}: PrintablePageFooterProps) => {
    const date = new Date().toLocaleDateString();
    const year = new Date().getFullYear();
    const fullName = ownerFullName ?? ownerEmail ?? t("aLinkUser");
    const printableText = t("printable-page--footer", {
        fullName,
        date,
        year,
    });

    // Need to add directly to the :root so that it's accessible from @page's @bottom-center while printing
    useEffect(() => {
        const root = document.documentElement;
        root.style.setProperty("--footer-text", `'${printableText}'`);
    }, [printableText]);

    return (
        <footer className={`${CSS_CLASS_NAME}__footer`}>
            <div className={`${CSS_CLASS_NAME}__footerContent`}>
                <span className={`${CSS_CLASS_NAME}__pageNumberWrapper`}>
                    {t("page")}{" "}
                    <span className={`${CSS_CLASS_NAME}__pageNumber`}></span>
                </span>
                <div className={`${CSS_CLASS_NAME}__createdByLinkWrapper`}>
                    <span className={`${CSS_CLASS_NAME}__footerText`}>
                        {t("printable-page--footer", {
                            fullName,
                            date,
                            year,
                        })}
                    </span>
                    <img
                        className={`${CSS_CLASS_NAME}__logo`}
                        src={logo}
                        alt={t("nfpaLogo")}
                    />
                </div>
            </div>
        </footer>
    );
};

export default PrintablePageFooter;
